import { Caption, Grid, Marker, Anchor } from '@design-systems/canvas-ui'
import { getUserDisplayName } from './userDisplayHelpers'

const getUserNameColumnDef = ({
  onClick,
}: {
  onClick?: (item: any) => void
}) => ({
  id: 'userId',
  header: 'User name',
  isRowHeader: true,
  show: true,
  // isSortable: true,
  isResizable: true,
  width: 150,
  accessorFn: (row: any) =>
    getUserDisplayName(row.firstName, row.lastName).toLowerCase(),
  cell: ({ row }: { row: any }) => {
    const item = row.original
    return (
      <Anchor onClick={() => onClick && onClick(item)}>
        <Caption below={item.email}>
          <strong>{getUserDisplayName(item.firstName, item.lastName)}</strong>
        </Caption>
      </Anchor>
    )
  },
})

const companyColumnDef = {
  id: 'company',
  header: 'Company',
  show: true,
  // isSortable: true,
  isResizable: true,
  width: 125,
  accessorKey: 'companyName',
}

const roleColumnDef = {
  id: 'role',
  header: 'Role',
  show: true,
  isResizable: true,
  width: 100,
  cell: ({ row }: { row: any }) => {
    const roles = row.original.roles || []
    return (
      <div>
        {roles.map((role: any, index: number) => (
          <div key={index}>
            {role.description}
            {index < roles.length - 1 ? ', ' : ''}
          </div>
        ))}
      </div>
    )
  },
}

const accreditationColumnDef = {
  id: 'accreditation',
  header: 'Accreditation',
  show: true,
  isResizable: true,
  width: 100,
  cell: ({ row }: { row: any }) => (
    <Grid.Container>
      {row.original.accreditations
        ?.filter((accreditation: any) => accreditation.status === 'COMPLETED')
        .map((accreditation: any, index: number) => (
          <Grid.Item key={index}>
            <Marker color="purple">{accreditation.code}</Marker>
          </Grid.Item>
        ))}
    </Grid.Container>
  ),
}

const statusColumnDef = {
  id: 'status',
  header: 'Status',
  show: true,
  // isSortable: true,
  width: 50,
  isResizable: true,
  accessorFn: (row: any) => (row.active ? 'Active' : 'Inactive'),
  cell: ({ row }: { row: any }) => {
    const item = row.original
    return (
      <Marker color={item.active ? 'green' : 'grey'}>
        {item.active ? 'Active' : 'Inactive'}
      </Marker>
    )
  },
}

export const teamsUserListColumnDefs = ({
  onUserNameClick,
}: {
  onUserNameClick?: (item: any) => void
} = {}) => [
  getUserNameColumnDef({ onClick: onUserNameClick }),
  companyColumnDef,
  roleColumnDef,
  accreditationColumnDef,
  statusColumnDef,
]

export const usersSearchColumnDefs = ({
  onUserNameClick,
}: {
  onUserNameClick?: (item: any) => void
} = {}) => [
  getUserNameColumnDef({ onClick: onUserNameClick }),
  companyColumnDef,
  accreditationColumnDef,
  statusColumnDef,
]
